import React, { useEffect, useState } from 'react';
import { CategoryType, EditMealType } from 'models/production-report.model';
import SelectDropdown from 'components/base/select-dropdown';
import useProductionReportContext from 'contexts/kitchen/production-report.context/context';
import { apiService } from 'services/base.service';
import { STORAGE_KEYS } from 'utils/constants';
import { toast } from 'react-toastify';
import { Input, ToastMessage } from '@cokitchen/cokitchen-components';

type Props = {
  meal: EditMealType;
  i: number;
  setFormData: (meals: EditMealType[]) => void;
  formData: EditMealType[];
};

const EditMealForm = ({ meal, i, setFormData, formData }: Props) => {
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);
  const { sections } = useProductionReportContext();
  const [mealCategories, setMealCategories] = useState<CategoryType[]>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, i: number) => {
    const { value, name } = e.target;
    setFormData(formData.map((meal, index) => (index === i ? { ...meal, [name]: value } : meal)));
  };

  const handleSelectChange = (value: { id: string; name: string }, i: number, field: string) => {
    setFormData(
      formData.map((meal, index) => {
        if (index === i) {
          if (field === 'section') {
            return { ...meal, [field]: value, category: { id: '', name: '' } };
          } else {
            return { ...meal, [field]: value };
          }
        } else {
          return meal;
        }
      })
    );
  };

  const fetchMealCategory = async () => {
    if (!meal.section.id) return;
    try {
      const res = await apiService.get(
        `cokitchen-item/cokitchen/${cokitchenId}/sections/${meal.section.id}/categories`
      );
      setMealCategories(res?.data);
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    }
  };

  useEffect(() => {
    fetchMealCategory();
  }, [cokitchenId, meal.section.id]);

  return (
    <div>
      <h2 className='font-semibold text-[32px] text-[#2E3031] mb-11'>Edit {meal.name}</h2>
      <div className='mb-[28px]'>
        <SelectDropdown
          options={sections?.slice(1)}
          value={meal.section.name}
          placeholder='Type section name'
          setValue={(value) => handleSelectChange(value, i, 'section')}
          label='Section'
        />
      </div>
      <div className='mb-[28px]'>
        <SelectDropdown
          options={mealCategories}
          value={meal.category.name}
          placeholder='Type category name'
          setValue={(value) => handleSelectChange(value, i, 'category')}
          label='Kitchen Item category'
        />
      </div>
      <div className='mb-[28px]'>
        <Input
          design='bordered'
          label='Kitchen Item name'
          value={meal.name}
          placeholder='Carb rice & spices'
          name='name'
          disabled={true}
          onChange={(e) => handleChange(e, i)}
        />
      </div>
      <div className='mb-16 relative'>
        <Input
          design='bordered'
          label='Min. qty'
          type='tel'
          pattern='[0-9]*'
          value={meal.qty}
          placeholder='00'
          name='qty'
          onChange={(e) => handleChange(e, i)}
        />
        <p className='text-sm text-[#96999C] absolute top-[55%] right-4 z-50'>Portion</p>
      </div>
    </div>
  );
};

export default EditMealForm;
